import FilterSection from './components/FilterSection/FilterSection';
import GridSection from './components/GridSection/GridSection';

import classes from './MSPlanBulkEditScreen.module.scss';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import MSSalesPlanNavigator from '../components/MSPlanSalesPlanNavigator/MSSalesPlanNavigator';
import ConfirmationModal from 'components/ConfirmationModal/ConfirmationModal';
import { useMSPlanBulkEdit } from './useMSPlanBulkEditScreen';

const SalesPlanBulkEditScreen = () => {
  const {
    editData,
    setEditData: _setEditData,
    setEditDataCopy: _setEditDataCopy,
    handleApplyFilter,
    filterData,
    pageNumber: _pageNumber,
    setPageNumber: _setPageNumber,
    isDataLoading,
    setIsDataLoading: _setIsDataLoading,
    getForecastValue,
    GFCNotesSet,
    setGFCNotesSet: _setGFCNotesSet,
    gfcCotSellingCategoryError,
    setgfcCotSellingCategoryError: _setgfcCotSellingCategoryError,
    handleSingleSave,
    handleSaveAllEdited,
    gfcCotSellingCategorySaveLoading,
    isSaveAllLoading,
    isNotesLoading,
    notesData,
    isNoteSaving,
    getNotesData: _getNotesData,
    handleAddNote,
    hasMore,
    nextPageLoading,
    loadMore,
    toggleVisibilityForNotes,
    handleSaveInputValue,
    isSaveAllBtnEnabled,
    checkGfcCotSCisSaving,
    isNotesButtonEnabled,
    handleNoteButtonClick,
    checkIfRowHasError: _checkIfRowHasError,
    isSaveButtonEnabled,
    focussedRowForNoteAdd,
    singleSaveConfirmationModalVisibility,
    saveAllConfirmationModalVisibility,
    setSingleSaveConfirmationModalVisibility,
    setSaveAllConfirmationModalVisibility,
    focussedRowForSaving,
    handleSingleSaveButtonClick,
    handleAllSaveButtonClick,
    isRouteChangeConfirmationPopUpVisible,
    handleSalesPlanButtonClick,
    handleGoToSalesPlan,
    toggleVisibilityForRouteConfirmationPopUp,
    GFCEditedSet,
    isCancelConfirmationPopVisible,
    handleCancelButtonClick,
    toggleCancelConfirmationPopUpVisibility,
    handleGoToTMSViewScreen,
    setNotesData,
    isNoteEdited,
    setIsNoteEdited,
    isNoteDeleted,
    setIsNoteDeleted,
    handleCopy,
    handleEditNote,
    handleDeleteNote,
    deletingNote,
    isNoteDeleting,
    isDeleteClicked,
    setIsDeleteClicked,
    setDeletingNote,
    initialLoading,
    // New accordion-related props
    expandedRows,
    toggleRowExpansion,
    handleMarketShareTypeChange,
    getMarketShareValueByType,
    isRowExpanded,
    getSelectedMarketShareType,
    // New business rule props
    getAvailableMarketShareTypes,
    getDefaultMarketShareType,
    isMarketShareTypeChangeable,
    // New concept sort prop
    handleConceptSort,
    // New row status prop
    getRowStatus,
    // New toggle display prop
    shouldShowToggle,
  } = useMSPlanBulkEdit();

  const _navigate = useNavigate();

  return (
    <div className={classes.container}>
      <MSSalesPlanNavigator
        currentScreen="msPlan"
        msPlanClick={() => {}}
        salesPlanClick={handleSalesPlanButtonClick}
      />
      {/* Filter component */}
      <FilterSection
        isDataLoading={isDataLoading}
        handleApplyFilter={handleApplyFilter}
        parentFilterPayload={filterData}
        daveToSaveIsThere={GFCEditedSet.size != 0}
      />
      {/* grid component */}
      <GridSection
        key={JSON.stringify(filterData)}
        dataLoading={isDataLoading}
        data={editData}
        initialLoading={initialLoading}
        handleCopy={handleCopy}
        getForecastValue={getForecastValue}
        handleSaveInputValue={handleSaveInputValue}
        isSaveButtonEnabled={isSaveButtonEnabled}
        isSaveAllBtnEnabled={isSaveAllBtnEnabled}
        gfcCotSCNotesErrorSet={gfcCotSellingCategoryError}
        handleSingleSave={handleSingleSaveButtonClick}
        handleSaveAllEdited={handleAllSaveButtonClick}
        checkGfcCotSCisSaving={checkGfcCotSCisSaving}
        isSaveAllLoading={isSaveAllLoading}
        isNotesButtonEnabled={isNotesButtonEnabled}
        handleNoteButtonClick={handleNoteButtonClick}
        hasMore={hasMore}
        loadMore={loadMore}
        nextPageLoading={nextPageLoading}
        filterData={filterData}
        visibility={focussedRowForNoteAdd !== null}
        handleCancel={toggleVisibilityForNotes}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        setNotesData={setNotesData}
        GFCNotesSet={GFCNotesSet}
        isNoteEdited={isNoteEdited}
        setIsNoteEdited={setIsNoteEdited}
        isNoteDeleted={isNoteDeleted}
        setIsNoteDeleted={setIsNoteDeleted}
        isNoteSaving={isNoteSaving}
        handleAddNote={handleAddNote}
        handleEditNote={handleEditNote}
        handleDeleteNote={handleDeleteNote}
        deletingNote={deletingNote}
        isNoteDeleting={isNoteDeleting}
        isDeleteClicked={isDeleteClicked}
        setIsDeleteClicked={setIsDeleteClicked}
        setDeletingNote={setDeletingNote}
        focussedRowForNoteAdd={focussedRowForNoteAdd}
        toggleVisibilityForNotes={toggleVisibilityForNotes}
        // New accordion-related props
        expandedRows={expandedRows}
        toggleRowExpansion={toggleRowExpansion}
        handleMarketShareTypeChange={handleMarketShareTypeChange}
        getMarketShareValueByType={getMarketShareValueByType}
        isRowExpanded={isRowExpanded}
        getSelectedMarketShareType={getSelectedMarketShareType}
        // New business rule props
        getAvailableMarketShareTypes={getAvailableMarketShareTypes}
        getDefaultMarketShareType={getDefaultMarketShareType}
        isMarketShareTypeChangeable={isMarketShareTypeChangeable}
        // New row status prop
        getRowStatus={getRowStatus}
        // New sorting prop
        handleConceptSort={handleConceptSort}
        // New toggle display prop
        shouldShowToggle={shouldShowToggle}
      />
      <div className={classes.btnContainer}>
        <Button className={classes.cancelBtn} onClick={handleCancelButtonClick}>
          Cancel
        </Button>
      </div>

      {/* <NotesSection
        visibility={focussedRowForNoteAdd !== null}
        handleCancel={toggleVisibilityForNotes}
        isNotesLoading={isNotesLoading}
        notesData={notesData}
        isNoteSaving={isNoteSaving}
        handleAddNote={handleAddNote}
      /> */}

      {/* single save confirmation modal */}
      {focussedRowForSaving && (
        <ConfirmationModal
          visibility={singleSaveConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to update the Market Share Plan ?`}
          loading={checkGfcCotSCisSaving(focussedRowForSaving)}
          confirmLabel="Update"
          handleCancel={() => setSingleSaveConfirmationModalVisibility(prev => !prev)}
          handleConfirm={() => handleSingleSave()}
        />
      )}

      {/* save all confirmation modal */}
      {saveAllConfirmationModalVisibility && (
        <ConfirmationModal
          visibility={saveAllConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to update the Market Share for all edited GFCs ?`}
          loading={isSaveAllLoading}
          confirmLabel="Update All"
          handleCancel={() => setSaveAllConfirmationModalVisibility(prev => !prev)}
          handleConfirm={handleSaveAllEdited}
        />
      )}

      {/* save all confirmation modal */}
      {focussedRowForSaving !== null && singleSaveConfirmationModalVisibility && (
        <ConfirmationModal
          visibility={singleSaveConfirmationModalVisibility}
          modalHeading="Confirmation"
          modalContent={`Are you sure want to update the Market Share Plan ? ?`}
          loading={gfcCotSellingCategorySaveLoading.has(
            `${editData[focussedRowForSaving].GFC}-${editData[focussedRowForSaving].COT}-${editData[focussedRowForSaving].SellingCategory}`
          )}
          confirmLabel="Update"
          handleCancel={() => setSingleSaveConfirmationModalVisibility(prev => !prev)}
          handleConfirm={handleSingleSave}
        />
      )}

      {/* save screen switch confirmation */}
      {isRouteChangeConfirmationPopUpVisible && (
        <ConfirmationModal
          visibility={isRouteChangeConfirmationPopUpVisible}
          modalHeading="Confirmation"
          modalContent={`You have not saved changes, are you sure you want to switch ?`}
          loading={false}
          confirmLabel="Confirm"
          handleCancel={toggleVisibilityForRouteConfirmationPopUp}
          handleConfirm={handleGoToSalesPlan}
        />
      )}

      {/* save screen switch confirmation */}
      {isCancelConfirmationPopVisible && (
        <ConfirmationModal
          visibility={isCancelConfirmationPopVisible}
          modalHeading="Confirmation"
          modalContent={`You have not saved changes, are you sure you want to cancel ?`}
          loading={false}
          confirmLabel="Confirm"
          handleCancel={toggleCancelConfirmationPopUpVisibility}
          handleConfirm={handleGoToTMSViewScreen}
        />
      )}
    </div>
  );
};

export default SalesPlanBulkEditScreen;
